import variantHasOptionValue from "./variantHasOptionValue";

const parseLabelOverrides = (value) => {
  if (!value) return [];
  try {
    const labels = JSON.parse(value);
    return Array.isArray(labels) ? labels : [];
  } catch {
    return [];
  }
};

export default function unifyGroupOptions(product) {
  if (!product) {
    return [];
  }

  const options = {};
  const optionLabels = {};

  const optionSources = [];

  optionSources.push(product);

  optionSources.forEach((optionSource) => {
    const enableMaterialGroup = optionSource.variants.some(
      (variant) => variant.customColor === "true",
    );

    const labelOverrides = parseLabelOverrides(
      optionSource.variantLabelOverride,
    );

    optionSource.options.forEach((option, index) => {
      if (
        option.name === "Title" &&
        option.optionValues[0]?.name === "Default Title"
      ) {
        return;
      }

      if (!(option.name in options)) {
        options[option.name] = [];
        optionLabels[option.name] = labelOverrides[index] || option.name;
      }
      options[option.name].push(
        ...option.optionValues
          .map((optionValue) => {
            const matchingVariants = optionSource.variants.filter((variant) =>
              variantHasOptionValue({
                variant,
                optionName: option.name,
                optionValue: optionValue.name,
              }),
            );

            const firstMatchingVariant = matchingVariants[0];

            let materialGroup = null;

            if (option.name === "Color" && enableMaterialGroup) {
              materialGroup =
                firstMatchingVariant?.customColor === "true"
                  ? window.localeStrings.product.custom_colors
                  : window.localeStrings.product.stocked_colors;
            }

            return {
              ...optionValue,
              materialGroup,
            };
          })
          .filter((v) => v),
      );
    });
  });

  const uniqueOptions = Object.entries(options).map(
    ([optionName, optionValues]) => {
      return {
        optionName,
        optionLabel: optionLabels[optionName],
        optionValues: optionValues.filter(
          ({ name }, i) =>
            optionValues.findIndex(
              (optionValue) => optionValue.name === name,
            ) === i,
        ),
      };
    },
  );

  return uniqueOptions;
}
